"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Text = void 0;
var react_1 = __importStar(require("react"));
require("../../../index.css");
var Text = /** @class */function (_super) {
  __extends(Text, _super);
  function Text() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  Text.prototype.render = function () {
    var className = "";
    var component = "";
    if (this.props.bold) {
      if (this.props.bold === "bold") {
        className = "font-bold ";
      } else {
        className = "font-semibold ";
      }
    }
    switch (this.props.size) {
      case "xs":
        className += "text-xs ";
        break;
      case "sm":
        if (this.props.mobile) className += "text-xs sm:text-sm ";else className += "text-sm ";
        break;
      case "base":
        if (this.props.mobile) className += "text-sm sm:text-base ";else className += "text-base ";
        break;
      case "lg":
        if (this.props.mobile) className += "text-base sm:text-lg ";else className += "text-lg ";
        break;
      case "xl":
        if (this.props.mobile) className += "text-lg sm:text-xl ";else className += "text-xl ";
        break;
      case "2xl":
        if (this.props.mobile) className += "text-xl sm:text-2xl ";else className += "text-2xl ";
        break;
      case "3xl":
        if (this.props.mobile) className += "text-2xl sm:text-3xl ";else className += "text-3xl ";
        break;
      case "4xl":
        if (this.props.mobile) className += "text-3xl sm:text-4xl ";else className += "text-4xl ";
        break;
    }
    //INFO : Default text-gray-700
    if (this.props.color) {
      switch (this.props.color) {
        case "pale":
          className += "text-gray-700 ";
          break;
        case "primary":
          className += "text-primary-600 ";
          break;
        case "secondary":
          className += "text-secondary-600 ";
          break;
      }
    }
    if (this.props.className) {
      className += this.props.className;
    }
    var title = this.props.children;
    switch (this.props.type) {
      case "h1":
        component = react_1.default.createElement("h1", {
          className: className
        }, title);
        break;
      case "h2":
        component = react_1.default.createElement("h2", {
          className: className
        }, title);
        break;
      case "h3":
        component = react_1.default.createElement("h3", {
          className: className
        }, title);
        break;
      case "h4":
        component = react_1.default.createElement("h4", {
          className: className
        }, title);
        break;
      case "h5":
        component = react_1.default.createElement("h5", {
          className: className
        }, title);
        break;
      case "h6":
        component = react_1.default.createElement("h6", {
          className: className
        }, title);
        break;
      case "p":
        component = react_1.default.createElement("p", {
          className: className
        }, title);
        break;
    }
    return component;
  };
  return Text;
}(react_1.Component);
exports.Text = Text;